"use strict";
import { useQuery } from "@tanstack/react-query";
import { TOPAZ_STATS_API_ENABLED, fetchStatsPools } from "api/topazStats/client";
import { UniverseChainId } from "features/chains/types";
const FIFTEEN_MINUTES_MS = 15 * 60 * 1e3;
const EMPTY_POOLS_MAP = /* @__PURE__ */ new Map();
export function useTopazStatsPools(chainId, enabled = true) {
  const apiEnabled = TOPAZ_STATS_API_ENABLED && enabled && chainId === UniverseChainId.Mainnet;
  const { data, isLoading, isError, isSuccess } = useQuery({
    queryKey: ["topazStatsPools", chainId],
    queryFn: async () => {
      const pools = await fetchStatsPools();
      const map = /* @__PURE__ */ new Map();
      for (const pool of pools) {
        if (pool.poolAddress) {
          map.set(pool.poolAddress.toLowerCase(), pool);
        }
      }
      return map;
    },
    enabled: apiEnabled,
    staleTime: FIFTEEN_MINUTES_MS,
    refetchInterval: FIFTEEN_MINUTES_MS,
    retry: 1
  });
  return {
    poolsByAddress: data ?? EMPTY_POOLS_MAP,
    isLoading: apiEnabled && isLoading,
    isError,
    isSuccess
  };
}
